import { createAsyncThunk } from "@reduxjs/toolkit";
import NDAService from "../../services/NDAService/NDAService";

// export const getDocuments = createAsyncThunk(
//   "/nda/documents",
//   async (companyId) => {
//     const res = NDAService.getNDADocuments(companyId);
//     ;
//     return res.data;
//   }
// );

export const getDocuments = createAsyncThunk(
  "/nda/documents",
  async (companyId) => {
    const res = await NDAService.getNDADocuments(companyId);
    return res.data;
  }
);

export const saveDocuments = createAsyncThunk(
  "/nda/documents",
  async (payload) => {
    const res = await NDAService.saveDocuments(payload);
    return res.data;
  }
);
